import { parseISODate } from './formDate';

const atMidnight = (d) => {
  const copy = new Date(d);
  copy.setHours(0, 0, 0, 0);
  return copy;
};

const addDays = (d, n) => {
  const copy = new Date(d);
  copy.setDate(copy.getDate() + n);
  return copy;
};

/**
 * Fenêtre de `days` jours, `offset` périodes avant celle qui finit aujourd'hui : 0 = les
 * `days` derniers jours, 1 = les `days` jours d'avant, etc. Bornes à minuit, incluses.
 *
 * `span` élargit la fenêtre vers le passé sans déplacer sa fin : les moyennes de
 * référence « sur 3 périodes » s'arrêtent au même jour que la période affichée.
 */
export function periodWindow(days, offset = 0, span = days) {
  const end = addDays(atMidnight(new Date()), -offset * days);
  return { start: addDays(end, -(span - 1)), end };
}

/** Les éléments dont la date tombe dans la fenêtre (bornes incluses). */
export function filterWindow(items, window, getDate) {
  if (!Array.isArray(items) || !window) return [];
  const { start, end } = window;
  return items.filter((item) => {
    const raw = getDate ? getDate(item) : item?.date;
    const parsed = raw ? parseISODate(raw) : null;
    if (!parsed) return false;
    const d = atMidnight(parsed);
    return d >= start && d <= end;
  });
}

/** Chaque jour de la fenêtre, du plus ancien au plus récent. */
export function windowDays(window) {
  const days = [];
  for (let d = new Date(window.start); d <= window.end; d = addDays(d, 1)) days.push(d);
  return days;
}

export function filterLastNDays(items, days, getDate) {
  const n = Number(days);
  if (!Array.isArray(items) || !Number.isFinite(n) || n <= 0) return [];
  return filterWindow(items, periodWindow(n), getDate);
}
